import api from '../api/client';
import React, { useEffect, useState } from 'react';
import '../Style/AboutHelp.css';

const AboutHelp = () => {
  const [pushDebugMsg, setPushDebugMsg] = useState('No push received yet');

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    const handler = (event) => {
      if (event.data?.type === 'PUSH_RECEIVED') {
        setPushDebugMsg(
          `Push received at ${new Date(event.data.arrivedAt).toLocaleTimeString()} with payload: ${JSON.stringify(event.data.payload)}`,
        );
      }
    };

    navigator.serviceWorker.addEventListener('message', handler);

    return () => {
      navigator.serviceWorker.removeEventListener('message', handler);
    };
  }, []);
  return (
    <div className="help-container">
      <h1>GLPT Guide</h1>

      <section>
        <h3>What is GLPT?</h3>
        <p>
          Global Legends Progress Tracker helps you set goals, track daily progress, and stay
          consistent over time. You can use it for fitness, studying, personal habits, creative
          work, or any area where showing up regularly matters.
        </p>
      </section>

      <section className="help-card help-card-gold">
        <h3>Progress and XP</h3>
        <p>
          GLPT uses XP and ranks to make progress easier to see. The goal is not to pressure you,
          but to give you feedback on your consistency.
        </p>
        <ul className="help-list">
          <li>
            <strong>Daily XP Cap:</strong> You can earn up to <strong>250 XP per day</strong>. After
            that, you can still complete goals, but your rank XP will stop increasing until the next
            day.
          </li>
          <li>
            <strong>Consistency Matters:</strong> Small check-ins add up. GLPT rewards regular
            progress more than short bursts of activity.
          </li>
          <li>
            <strong>Rank Decay:</strong> If you are inactive for <strong>25 days</strong>, your rank
            can slowly drop every <strong>14 days</strong>. Your total lifetime XP does not go down.
          </li>
        </ul>
      </section>

      <section className="help-card help-card-blue">
        <h3>Privacy and Control</h3>
        <p>
          You control what other people can see. You can keep your profile public, make it private,
          or hide specific goals and notes.
        </p>
        <ul className="help-list">
          <li>
            <strong>Private Profile:</strong> Hide your goals, achievements, activity, and progress
            from users who do not follow you.
          </li>
          <li>
            <strong>Goal Privacy:</strong> Hide individual goals while keeping the rest of your
            profile public.
          </li>
          <li>
            <strong>Private Notes:</strong> Keep personal reflections or details hidden while still
            sharing the goal itself.
          </li>
          <li>
            <strong>Public Profile:</strong> Your name, bio, rank, and public goals help others
            understand what you are working on.
          </li>
        </ul>
      </section>

      <section>
        <h3>Goals</h3>
        <p>
          Your Goals page is where you create goals, mark daily progress, add notes, and track your
          consistency over time.
        </p>
        <ul className="help-list">
          <li>
            <strong>Year Calendar:</strong> See your activity across the last 12 months.
          </li>
          <li>
            <strong>Goal Cards:</strong> Open a goal to view check-ins, notes, entries, and
            progress.
          </li>
          <li>
            <strong>Daily Check-ins:</strong> Mark goals complete for the day to build your
            progress.
          </li>
        </ul>
      </section>

      <section>
        <h3>Archive</h3>
        <p>
          Archive goals you want to keep but are not actively working on. Archived goals stay saved
          without cluttering your main Goals page.
        </p>
      </section>

      <section>
        <h3>Achievements</h3>
        <p>
          When a goal is fully completed, you can move it to Achievements. This keeps a record of
          goals you have finished.
        </p>
      </section>

      <section>
        <h3>Leaderboard</h3>
        <p>
          The leaderboard shows how users rank based on XP and consistency. You can compare your
          progress globally or with people you follow.
        </p>
      </section>

      <section>
        <h3>Activity Feed</h3>
        <p>
          The Activity Feed shows recent progress from the community and from people you follow.
        </p>
        <ul className="help-list relaxed">
          <li>
            <strong>Global Feed:</strong> Public users can appear here after checking off at least
            <strong> 2 public goals</strong> today.
          </li>
          <li>
            <strong>Following Feed:</strong> People you follow can appear here after
            <strong> 1 goal check-in</strong>.
          </li>
          <li>
            <strong>Private Accounts:</strong> Private users only appear in your Following Feed
            after they approve your follow request. They do not appear in the Global Feed.
          </li>
        </ul>
      </section>

      <section>
        <h3>Service Requests</h3>
        <h4>Service Requests is FREE!</h4>
        <p>
          Service Requests let you ask for help with account or progress-related issues. Some
          requests may require a small support payment before review, depending on the type of
          request.
        </p>
        <ul className="help-list">
          <li>
            <strong>Submit a request:</strong> Explain what happened and what you need help with.
          </li>
          <li>
            <strong>Track your request:</strong> View the status of your submitted requests in your
            request history.
          </li>
          <li>
            <strong>Admin review:</strong> Requests are reviewed before any changes are made,
            helping keep the system fair.
          </li>
        </ul>
      </section>

      <section className="help-card help-card-blue">
        <h3>Install GLPT</h3>
        <p>
          You can add GLPT to your phone or tablet home screen for a faster app-like experience.
        </p>
        <ul className="help-list">
          <li>
            <strong>iPhone/iPad:</strong> Open GLPT in Safari, tap Share, then choose Add to Home
            Screen.
          </li>
          <li>
            <strong>Android:</strong> Open GLPT in Chrome and choose Install App or Add to Home
            Screen.
          </li>
        </ul>
      </section>
    </div>
  );
};

export default AboutHelp;
